import React from 'react'
import { Button, Modal } from 'antd'
import PropTypes from 'prop-types'

const ConfirmationModal = ({
	show,
	title,
	text,
	onCancel,
	onConfirm,
	cancelText = 'Cancelar',
	confirmText = 'Confirmar',
	loading = false,
}) => {
	const handleCancel = () => {
		onCancel()
	}

	const handleConfirm = () => {
		onConfirm()
	}

	const footerButtons = () => {
		return [
			<Button key="cancel" onClick={() => handleCancel()}>
				{cancelText}
			</Button>,
			<Button
				key="confirm"
				onClick={() => handleConfirm()}
				loading={loading}
				disabled={loading}>
				{confirmText}
			</Button>,
		]
	}

	return (
		<Modal
			open={show}
			onCancel={() => handleCancel()}
			destroyOnClose={true}
			title={title}
			footer={footerButtons()}>
			<p>{text}</p>
		</Modal>
	)
}

ConfirmationModal.propTypes = {
	show: PropTypes.bool,
	title: PropTypes.string,
	text: PropTypes.string,
	onCancel: PropTypes.func,
	onConfirm: PropTypes.func,
	cancelText: PropTypes.string,
	confirmText: PropTypes.string,
	loading: PropTypes.bool,
}

export default ConfirmationModal
